import { faHouseMedical } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation } from 'react-router';

import { Breadcrumbs } from '../components/Breadcrumbs';
import { DashboardNavigator } from '../components/DashboardNavigator';
import { Filters } from '../components/filters/Filters';

export const PracticeHeader = ({ practiceName }: { practiceName?: string }) => {
  const location = useLocation();
  const id =
    location.pathname.split('practice/')[1].split('/')[0] === 'undefined'
      ? undefined
      : location.pathname.split('practice/')[1].split('/')[0];

  return (
    <div className="vai-flex vai-flex-col vai-gap-4 vai-w-full">
      <Breadcrumbs practiceName={practiceName} />
      <div className="vai-flex vai-flex-row vai-gap-2 vai-items-center">
        {practiceName && <FontAwesomeIcon icon={faHouseMedical} />}
        <span className="vai-typography-h4">{practiceName}</span>
      </div>
      <DashboardNavigator />
      <Filters
        selectedDrilldownPractices={id ? [id] : undefined}
        enableProviderRoleFilter={true}
        enableTasksFilter={location.pathname.includes('hygiene')}
        enableMaterialityFilter={location.pathname.includes('clinical')}
      />
    </div>
  );
};
